import { Controller } from "@hotwired/stimulus";

/**
 * Recharge la page à intervalle régulier tant que l'élément est affiché
 * (suivi d'un traitement en tâche de fond : étapes, compteurs).
 *
 * <section data-controller="page-refresh" data-page-refresh-interval-value="2000">
 */
export default class extends Controller {
  static values = { interval: { type: Number, default: 2000 } };

  connect() {
    this.timer = setTimeout(() => {
      if (window.Turbo) {
        window.Turbo.visit(window.location.href, { action: "replace" });
      } else {
        window.location.reload();
      }
    }, this.intervalValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
